import { SourceEntity } from 'types/SourceEntity'
import ApiBase from './Api'
import { toSnakeCase } from '../packages/utils/casing'

type IssueFields = {
    statusStage: number
    statusComplete: boolean
}

type NewSource = {
    issueId?: string
    convertibleId?: string
    sourceUrl: string
    sourceType: string
    title: string
    publishedDate: Date
    releaseDatetime: Date
}

const SOURCE_API_PATHS = {
    SOURCES: '/sources',
    SOURCES_ADMIN: '/admin/sources',
}

class SourceApi extends ApiBase {
    async findByField({ prId, sourceUrl }: { prId?: string; sourceUrl?: string }) {
        const response: SourceEntity[] = await this._getRequest(SOURCE_API_PATHS.SOURCES, {
            queryParameters: toSnakeCase({
                sourceUrl: sourceUrl ? encodeURI(sourceUrl) : null,
                prId: prId ?? null,
            }),
        })
        return response
    }

    async findByIssueId(issueId: string) {
        const response: SourceEntity[] = await this._getRequest(SOURCE_API_PATHS.SOURCES, {
            queryParameters: toSnakeCase({ issueId }),
        })
        return response
    }
    async findByWarrantId(warrantId: string) {
        const response: SourceEntity[] = await this._getRequest(SOURCE_API_PATHS.SOURCES, {
            queryParameters: toSnakeCase({ warrantId }),
        })
        return response
    }
    async findByConvertibleId(convertibleId: string) {
        const response: SourceEntity[] = await this._getRequest(SOURCE_API_PATHS.SOURCES, {
            queryParameters: toSnakeCase({ convertibleId }),
        })
        return response
    }
    async create(newSource: NewSource, issueFields?: IssueFields) {
        const response = await this._postRequest(
            SOURCE_API_PATHS.SOURCES_ADMIN,
            toSnakeCase({
                ...newSource,
                issueFields,
            }),
        )
        return response
    }
}

export default SourceApi
